export const GLOBAL_CHART = {
  "Chart.Space.Around": {
    defaultValue: "default"
  },
  "Chart.Space.Around.Top": {
    defaultValue: "2px"
  },
  "Chart.Space.Around.Right": {
    defaultValue: "2px"
  },
  "Chart.Space.Around.Bottom": {
    defaultValue: "2px"
  },
  "Chart.Space.Around.Left": {
    defaultValue: "2px"
  },

  "Chart.Height.Type": {
    defaultValue: "fixed"
  },

  //caption added
  "Chart.Title.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Chart.Title.Padding.Top": {
    defaultValue: "0px"
  },
  "Chart.Title.Padding.Right": {
    defaultValue: "0px"
  },
  "Chart.Title.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Chart.Title.Padding.Left": {
    defaultValue: "0px"
  },
  "Chart.Title.Font.Size": {
    ref: "Font.Size.16"
  },
  "Chart.Title.Color": {
    ref: "Color.Gray.800"
  },
  "Chart.Title.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },

  //chart view

  "Chart.Bg.Color": {
    ref: "Color.Transparent"
  },

  "Chart.Overflow": {
    defaultValue: "auto"
  },

  "Chart.Height": {
    defaultValue: "300px"
  },
  "Chart.Width": {
    defaultValue: "300px"
  },
  "Chart.Min.Height": {
    defaultValue: "300px"
  },
  "Chart.Min.Width": {
    defaultValue: "300px"
  },
  "Chart.Max.Height": {
    defaultValue: "unset"
  },
  "Chart.Max.Width": {
    defaultValue: "unset"
  },

  "Chart.Margin.Top": {
    defaultValue: "0px"
  },
  "Chart.Margin.Right": {
    defaultValue: "0px"
  },
  "Chart.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Chart.Margin.Left": {
    defaultValue: "0px"
  },

  "Chart.Padding.Top": {
    defaultValue: "0px"
  },
  "Chart.Padding.Right": {
    defaultValue: "0px"
  },
  "Chart.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Chart.Padding.Left": {
    defaultValue: "0px"
  },

  "Chart.Border.Style": {
    defaultValue: "solid"
  },
  "Chart.Border.Color": {
    ref: "Color.Transparent"
  },

  "Chart.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Chart.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Chart.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Chart.Border.Bottom.Width": {
    defaultValue: "0px"
  },

  "Chart.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Chart.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Chart.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Chart.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },

  "Chart.Shadow": {
    defaultValue: "none"
  },
  "Chart.Shadow.Type": {
    defaultValue: "none"
  },
  "Chart.Shadow.Color": {
    ref: "Color.Shadow"
  },
  "Chart.Box.Sizing": {
    defaultValue: "border-box"
  }
};
